export default "__VITE_ASSET__6_D9EOot__"